import { BrainGameInterface } from "./interface";
import { BRAIN_GAME_ACTIONS, BrainGameState } from "./types";

const initialState: BrainGameState = {
    gameData: undefined,
    activeEntry: undefined,
};

const brainGameReducer = (
    state: BrainGameState | undefined,
    action: BrainGameInterface
): BrainGameState => {

    if (typeof state === 'undefined') {
        state = initialState;
    }

    switch (action.type) {
        case BRAIN_GAME_ACTIONS.setGameData:
            return {
                ...state,
                gameData: action.payload,
            };
        case BRAIN_GAME_ACTIONS.setActiveEntry:
            return {
                ...state,
                activeEntry: action.payload,
            };
        case BRAIN_GAME_ACTIONS.removeActiveEntry:
            return {
                ...state,
                activeEntry: undefined,
            }
        case BRAIN_GAME_ACTIONS.setActiveLanguage:
            return {
                ...state,
                activeLanguage: action.payload,
            }
        default:
            return state;
    }
}

export { brainGameReducer };
